module.exports = __webpack_public_path__ + "static/media/Silder3.c0330d99.png";